import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fill',
    standalone: false
})
export class ArrayFillPipe implements PipeTransform {
  transform(value: number, ...args: any[]): any {
    return new Array(value).fill(1);
  }
}
